import { TemplateId } from "../../globalTypes";
import { FavouriteTemplate } from "../../store/favouriteTemplates/types";
import wrappedAxios from "../axiosWrapper";
import * as urlParsers from "./urlParsers";

export const fetchFavouriteTemplates = () =>
  wrappedAxios<FavouriteTemplate[]>({
    url: urlParsers.getFavouriteTemplates(),
    method: "get",
  });

export const addFavouriteTemplate = (templateId: TemplateId) =>
  wrappedAxios<void>({
    url: urlParsers.addFavouriteTemplate(templateId),
    method: "POST",
  });

export const removeFavouriteTemplate = (templateId: TemplateId) =>
  wrappedAxios<void>({
    url: urlParsers.removeFavouriteTemplate(templateId),
    method: "delete",
  });

export const patchFavouriteTemplate = (
  templateId: TemplateId,
  payload: { order: number }
) =>
  wrappedAxios<void>({
    url: urlParsers.patchFavouriteTemplate(templateId),
    method: "PATCH",
    data: payload,
  });
